/**
 * トップFV：フェードスライダー
 */
function initHomeFvSlider() {
  const slider = document.querySelector('.p-home-fv-slider');
  if (!slider) return;

  const items = [...slider.querySelectorAll('.p-home-fv-slider__item')];
  if (items.length <= 1) return;

  const prevBtn = slider.querySelector('.p-home-fv-slider__prev');
  const nextBtn = slider.querySelector('.p-home-fv-slider__next');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const transitionMs = prefersReducedMotion ? 0 : 3000;
  const autoplayDelay = 7000;

  let currentIndex = items.findIndex((item) => item.classList.contains('is-active'));
  if (currentIndex < 0) currentIndex = 0;

  let isTransitioning = false;
  let autoplayTimer = null;

  const normalizeIndex = (index) => (index + items.length) % items.length;

  const updateSlides = () => {
    items.forEach((item, index) => {
      const isActive = index === currentIndex;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  };

  const goTo = (index) => {
    const nextIndex = normalizeIndex(index);
    if (nextIndex === currentIndex || isTransitioning) return;

    if (transitionMs === 0) {
      currentIndex = nextIndex;
      updateSlides();
      return;
    }

    isTransitioning = true;
    currentIndex = nextIndex;
    updateSlides();

    window.setTimeout(() => {
      isTransitioning = false;
    }, transitionMs);
  };

  const goNext = () => {
    goTo(currentIndex + 1);
  };

  const goPrev = () => {
    goTo(currentIndex - 1);
  };

  const stopAutoplay = () => {
    if (autoplayTimer) {
      window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  };

  const startAutoplay = () => {
    stopAutoplay();
    autoplayTimer = window.setInterval(goNext, autoplayDelay);
  };

  const resetAutoplay = () => {
    stopAutoplay();
    startAutoplay();
  };

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      goPrev();
      resetAutoplay();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      goNext();
      resetAutoplay();
    });
  }

  slider.addEventListener('mouseenter', stopAutoplay);
  slider.addEventListener('mouseleave', startAutoplay);

  slider.addEventListener('focusin', stopAutoplay);
  slider.addEventListener('focusout', (event) => {
    if (!slider.contains(event.relatedTarget)) {
      startAutoplay();
    }
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      stopAutoplay();
      return;
    }
    startAutoplay();
  });

  updateSlides();
  startAutoplay();
}

/**
 * トップFVコースバナー：横スライド（ボタン・ドラッグ・フリック）
 */
function initHomeFvBottomSlider() {
  const slider = document.querySelector('.p-home-fv-bottom-slider');
  if (!slider) return;

  const viewport = slider.querySelector('.p-home-fv-bottom-slider__viewport');
  const list = slider.querySelector('.p-home-fv-bottom-slider__list');
  const originalItems = [...slider.querySelectorAll('.p-home-fv-bottom-slider__item')];
  const prevBtn = slider.querySelector('.p-home-fv-bottom-slider__prev');
  const nextBtn = slider.querySelector('.p-home-fv-bottom-slider__next');
  if (!viewport || !list || originalItems.length <= 1) return;

  const slideCount = originalItems.length;
  const clone = originalItems[0].cloneNode(true);
  clone.classList.remove('is-active');
  clone.setAttribute('aria-hidden', 'true');
  list.appendChild(clone);

  const items = [...originalItems, clone];

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const transitionMs = prefersReducedMotion ? 0 : 2000;
  const autoplayDelay = 7000;
  const dragThreshold = 50;

  let currentIndex = originalItems.findIndex((item) => item.classList.contains('is-active'));
  if (currentIndex < 0) currentIndex = 0;

  let isTransitioning = false;
  let isDragging = false;
  let dragStartX = 0;
  let dragDeltaX = 0;
  let autoplayTimer = null;

  const setAria = () => {
    items.forEach((item, index) => {
      const isActive = index === currentIndex;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  };

  const applyTransition = (enabled) => {
    if (!enabled || transitionMs === 0) {
      list.style.transition = 'none';
      return;
    }
    list.style.transition = 'transform 2s ease';
  };

  const setTransform = (offsetPx = 0) => {
    list.style.transform = `translate3d(calc(-${currentIndex * 100}% + ${offsetPx}px), 0, 0)`;
  };

  const updateSlides = (offsetPx = 0, withTransition = true) => {
    applyTransition(withTransition && offsetPx === 0);
    setTransform(offsetPx);
    setAria();
  };

  const jumpTo = (index) => {
    applyTransition(false);
    currentIndex = index;
    setTransform(0);
    setAria();
    list.offsetHeight;
  };

  const finishTransition = () => {
    window.setTimeout(() => {
      isTransitioning = false;
    }, transitionMs);
  };

  const goNext = () => {
    if (isTransitioning || isDragging) return;

    if (transitionMs === 0) {
      currentIndex = (currentIndex + 1) % slideCount;
      updateSlides();
      return;
    }

    if (currentIndex === slideCount - 1) {
      isTransitioning = true;
      currentIndex = slideCount;
      updateSlides();

      const onTransitionEnd = (event) => {
        if (event.target !== list || event.propertyName !== 'transform') return;
        list.removeEventListener('transitionend', onTransitionEnd);
        jumpTo(0);
        isTransitioning = false;
      };

      list.addEventListener('transitionend', onTransitionEnd);
      return;
    }

    isTransitioning = true;
    currentIndex += 1;
    updateSlides();
    finishTransition();
  };

  const goPrev = () => {
    if (isTransitioning || isDragging) return;

    if (transitionMs === 0) {
      currentIndex = (currentIndex - 1 + slideCount) % slideCount;
      updateSlides();
      return;
    }

    if (currentIndex === 0) {
      isTransitioning = true;
      jumpTo(slideCount);

      requestAnimationFrame(() => {
        currentIndex = slideCount - 1;
        updateSlides();
        finishTransition();
      });
      return;
    }

    isTransitioning = true;
    currentIndex -= 1;
    updateSlides();
    finishTransition();
  };

  const stopAutoplay = () => {
    if (autoplayTimer) {
      window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  };

  const startAutoplay = () => {
    stopAutoplay();
    autoplayTimer = window.setInterval(goNext, autoplayDelay);
  };

  const resetAutoplay = () => {
    stopAutoplay();
    startAutoplay();
  };

  const onDragStart = (clientX) => {
    if (isTransitioning) return;
    isDragging = true;
    dragStartX = clientX;
    dragDeltaX = 0;
    stopAutoplay();
    applyTransition(false);
    viewport.classList.add('is-dragging');
  };

  const onDragMove = (clientX) => {
    if (!isDragging) return;
    dragDeltaX = clientX - dragStartX;
    setTransform(dragDeltaX);
  };

  const onDragEnd = () => {
    if (!isDragging) return;
    isDragging = false;
    viewport.classList.remove('is-dragging');

    if (dragDeltaX <= -dragThreshold) {
      goNext();
    } else if (dragDeltaX >= dragThreshold) {
      goPrev();
    } else {
      updateSlides();
    }

    dragDeltaX = 0;
    resetAutoplay();
  };

  if (prevBtn) {
    prevBtn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      goPrev();
      resetAutoplay();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      goNext();
      resetAutoplay();
    });
  }

  viewport.addEventListener('pointerdown', (event) => {
    if (event.button !== 0 && event.pointerType === 'mouse') return;
    onDragStart(event.clientX);
    viewport.setPointerCapture(event.pointerId);
  });

  viewport.addEventListener('pointermove', (event) => {
    if (!isDragging) return;
    onDragMove(event.clientX);
    if (event.pointerType !== 'mouse') {
      event.preventDefault();
    }
  });

  viewport.addEventListener('pointerup', (event) => {
    if (!viewport.hasPointerCapture(event.pointerId)) return;
    viewport.releasePointerCapture(event.pointerId);
    onDragEnd();
  });

  viewport.addEventListener('pointercancel', (event) => {
    if (viewport.hasPointerCapture(event.pointerId)) {
      viewport.releasePointerCapture(event.pointerId);
    }
    onDragEnd();
  });

  slider.addEventListener('mouseenter', stopAutoplay);
  slider.addEventListener('mouseleave', () => {
    if (!isDragging) {
      startAutoplay();
    }
  });

  slider.addEventListener('focusin', stopAutoplay);
  slider.addEventListener('focusout', (event) => {
    if (!slider.contains(event.relatedTarget)) {
      startAutoplay();
    }
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      stopAutoplay();
      return;
    }
    startAutoplay();
  });

  updateSlides();
  startAutoplay();
}

document.addEventListener('DOMContentLoaded', () => {
  initHomeFvSlider();
  initHomeFvBottomSlider();
});
